"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _request = _interopRequireDefault(require("./request"));

var _extend = _interopRequireDefault(require("lodash/extend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// This is an internal module -- use chainedRequest() instead.
var RequestWrapper = /*#__PURE__*/function () {
  function RequestWrapper(dispatcher) {
    _classCallCheck(this, RequestWrapper);

    this.dispatcher = dispatcher;
  }

  _createClass(RequestWrapper, [{
    key: "withLoadSpinner",
    value: function withLoadSpinner(customEvent) {
      var eventName = customEvent || "SHOW_LOAD_SPINNER";

      if (!this.aborted) {
        this.showingLoadSpinner = true;
        this.dispatcher.emit(eventName);
      }

      return this;
    }
  }, {
    key: "postWithAttachment",
    value: function postWithAttachment(endpoint, file, errMsg) {
      var req = this.post(endpoint);

      if (!this.aborted) {
        if (!file || !file.name) {
          errMsg = errMsg || "Oops! We couldn't find anything to upload.";
          this.dispatcher.emit("SHOW_FLASH_MESSAGE", {
            message: errMsg,
            className: "warning"
          });

          this.__abort(req);
        } else {
          req.attach(file.name, file);
        }
      }

      return req;
    }
  }]);

  return RequestWrapper;
}(); // Add the actual request methods (get, post, etc.)


(0, _extend.default)(RequestWrapper.prototype, _request.default);
var _default = RequestWrapper;
exports.default = _default;